// Facebook App ID
// https://developers.facebook.com/

// Owner: Ardis
export const oAuthFacebookAppId = '1778411812395435';

// Owner: Sasa
export const oAuthFacebookAppIdDev = '284380045468867';
